import { render } from "./SongCategories.vue?vue&type=template&id=42cc078d&scoped=true&ts=true"
import script from "./SongCategories.vue?vue&type=script&lang=ts"
export * from "./SongCategories.vue?vue&type=script&lang=ts"

import "./SongCategories.vue?vue&type=style&index=0&id=42cc078d&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Roshaw\\WebstormProjects\\random-song\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42cc078d"]])

export default __exports__